/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const SELECTED_CLIENT_ACTION_TYPES = 'SELECTED_CLIENT_ACTION_TYPES';
export const CLIENT_DATA_ACTION_TYPES = 'CLIENT_DATA_ACTION_TYPES';
export const GROUP_ADD_ACTION_TYPES = 'GROUP_ADD_ACTION_TYPES';
export const CLIENT_ID_DROPDOWN_ACTION_TYPES =
  'CLIENT_ID_DROPDOWN_ACTION_TYPES';
export const MAINTIN_GROUP_DETAILS_ACTION_TYPES =
  'MAINTIN_GROUP_DETAILS_ACTION_TYPES';
export const MAINTAIN_GROUP_COMPARE_DATA = 'MAINTAIN_GROUP_COMPARE_DATA';

export const MAINTAIN_GROUP_PARTICIPATION_DATES_ACTION_TYPES =
  'MAINTAIN_GROUP_PARTICIPATION_DATES_ACTION_TYPES';
export const MAINTAIN_GROUP_PLANS_ACTION_TYPES =
  'MAINTAIN_GROUP_PLANS_ACTION_TYPES';
export const MAINTAIN_GROUP_CONTACT_ACTION_TYPES =
  'MAINTAIN_GROUP_CONTACT_ACTION_TYPES';
export const GET_CONTACT_TYPE = 'GET_CONTACT_TYPE';
export const CREATE_NEW_GRP_OPT = 'CREATE_NEW_GRP_OPT';
export const GET_EXISTING_CONTACT_DETAILS = 'GET_EXISTING_CONTACT_DETAILS';
export const GET_CONTACT_DETAILS = 'GET_CONTACT_DETAILS';
export const UPDATE_CONTACT_DETAILS = 'UPDATE_CONTACT_DETAILS';
export const NAVIGATION_LISTENER_ACTION_TYPES =
  'NAVIGATION_LISTENER_ACTION_TYPES';
export const ERROR_POPUP_ACTION_TYPES = 'ERROR_POPUP_ACTION_TYPES';
export const GROUP_DATA_CHANGE_TRIED = 'GROUP_DATA_CHANGE_TRIED';
export const COMPARE_GROUP_CONTACT_INFO = 'COMPARE_GROUP_CONTACT_INFO';
export const SAVE_OR_FAIL_RES = 'SAVE_OR_FAIL_RES';
export const GROUP_TAB_DATA = 'GROUP_TAB_DATA';
export const SET_SELECTED_GROUP = 'SET_SELECTED_GROUP';
export const SET_CLEAR_REDUX_DATA = 'SET_CLEAR_REDUX_DATA';
export const CLEAR_SAVE_OR_FAIL_RES = "CLEAR_SAVE_OR_FAIL_RES"